import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";

import { LanguageModule } from "@intocare/language";
import { PipesModule } from "@intocare/pipes";
import { MyDatePickerModule } from "@intocare/ui-my-date-picker";

import { AutoCompleteComponent } from "./autocomplete/autocomplete.component";
import { BladeInputComponent } from "./blade/blade.component";
import { DateInputCellComponent } from "./cell/date-cell/date-cell.component";
import { NumberCellInputComponent } from "./cell/number-cell/number-cell.component";
import { NumberSuffixCellFieldComponent } from "./cell/number-suffix-cell/number-suffix-cell.component";
import { NumberSuggestionCellInputComponent } from "./cell/number-suggestion-cel/number-suggestion-cell.component";
import { SearchCellComponent } from "./cell/search-cell/search-cell.component";
import { SelectCellComponent } from "./cell/select-cell/select-cell.component";
import { TextCellInputComponent } from "./cell/text-cell/text-cell.component";
import { TimeIntervalInputCellComponent } from "./cell/time-interval-cell/time-interval-input-cell.component";
import { CheckBoxComponent } from "./checkbox/input.component";
import { ColorInputComponent, ColorOptionComponent } from "./color/input.component";
import { DateInputComponent } from "./date/input.component";
import { directives, nonStandaloneDirectives } from "./directives";
import { FileInputComponent } from "./file/file-input.component";
import { FileInputTemplateComponent } from "./file-input-template/file-input-template.component";
import { GroupedAutoCompleteComponent } from "./grouped-autocomplete/grouped-autocomplete.component";
import { IconInputComponent } from "./icon/input.component";
import { ItemFormGroupModule } from "./item-formgroup/item-form-group.module";
import { InputLabelComponent } from "./label/label.component";
import { ListFilterComponent } from "./list-filter/list-filter.component";
import { LockedInputComponent } from "./locked/input.component";
import { MultiTextInputComponent } from "./multi/input.component";
import { MultiTextAreaInputComponent } from "./multi-text-area/multi-text-area.component";
import { NumberInputComponent } from "./number/input.component";
import { RadioComponent } from "./radio/input.component";
import { SearchSelectComponent } from "./search/search.component";
import { SegmentComponent } from "./segment/segment.component";
import { SelectComponent, SelectOptionComponent } from "./select/select.component";
import { SelectorComponent } from "./selector/selector.component";
import { KeyboardService } from "./services/keyboard.service";
import { StatusBoardInputComponent } from "./status-board/input.component";
import { TextInputComponent } from "./text/input.component";
import { TextAreaInputComponent } from "./text-area/input.component";
import { TimeInputComponent } from "./time/input.component";
import { TimeIntervalInputComponent } from "./time-interval/time-interval-input.component";
import { ToggleComponent } from "./toggle/input.component";
import { ButtonModule } from "../button/button.module";
import { UIDirectivesModule } from "../directives";
import { IconModule } from "../icon/icon.module";
import { IndicatorModule } from "../indicator/indicator.module";
import { MessageWarningComponent } from "../message-warning/message-warning.component";

const exportedModules = [ItemFormGroupModule];

@NgModule({
	imports: [
		...directives,
		CommonModule,
		TranslateModule,
		MatTooltipModule,
		LanguageModule,
		IndicatorModule,
		MyDatePickerModule,
		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		IconModule,
		PipesModule,
		DragDropModule,
		NgxMaskDirective,
		NgxMaskPipe,
		ButtonModule,
		UIDirectivesModule,
		MessageWarningComponent,
		...exportedModules,
		FormsModule,
	],
	declarations: [
		...nonStandaloneDirectives,
		SelectComponent,
		SelectOptionComponent,
		TextInputComponent,
		LockedInputComponent,
		TextAreaInputComponent,
		CheckBoxComponent,
		ToggleComponent,
		RadioComponent,
		SearchSelectComponent,
		ColorInputComponent,
		ColorOptionComponent,
		MultiTextInputComponent,
		DateInputComponent,
		IconInputComponent,
		SegmentComponent,
		AutoCompleteComponent,
		TimeIntervalInputComponent,
		GroupedAutoCompleteComponent,
		NumberCellInputComponent,
		SelectCellComponent,
		NumberSuffixCellFieldComponent,
		DateInputCellComponent,
		InputLabelComponent,
		ListFilterComponent,
		TimeIntervalInputCellComponent,
		TextCellInputComponent,
		MultiTextAreaInputComponent,
		FileInputComponent,
		SearchCellComponent,
		NumberSuggestionCellInputComponent,
		BladeInputComponent,
		StatusBoardInputComponent,
		NumberInputComponent,
		TimeInputComponent,
		SelectorComponent,
		FileInputTemplateComponent,
	],
	exports: [
		SelectComponent,
		SelectOptionComponent,
		TextInputComponent,
		LockedInputComponent,
		TextAreaInputComponent,
		CheckBoxComponent,
		ToggleComponent,
		RadioComponent,
		SearchSelectComponent,
		ColorInputComponent,
		MultiTextInputComponent,
		IconInputComponent,
		DateInputComponent,
		SegmentComponent,
		AutoCompleteComponent,
		TimeIntervalInputComponent,
		GroupedAutoCompleteComponent,
		NumberCellInputComponent,
		SelectCellComponent,
		NumberSuffixCellFieldComponent,
		DateInputCellComponent,
		InputLabelComponent,
		ListFilterComponent,
		TimeIntervalInputCellComponent,
		TextCellInputComponent,
		MultiTextAreaInputComponent,
		FileInputComponent,
		SearchCellComponent,
		NumberSuggestionCellInputComponent,
		BladeInputComponent,
		StatusBoardInputComponent,
		NumberInputComponent,
		TimeInputComponent,
		SelectorComponent,
		exportedModules,
		FileInputTemplateComponent,
	],
	providers: [KeyboardService, provideNgxMask()],
})
export class InputModule {}
